import StyledTick from './StyledTick';

export default StyledTick;
